import dayjs from 'dayjs'

export default {
  'duration' : seconds => {
    seconds = Number(seconds);
    const d = Math.floor(seconds / (3600*24));
    const h = Math.floor(seconds % (3600*24) / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = Math.floor(seconds % 60);

    const dDisplay = d > 0 ? d + "天" : "";
    const hDisplay = h > 0 ? h + "小时" : "";
    const mDisplay = m > 0 ? m + "分钟" : "";
    const sDisplay = s > 0 ? s + "秒" : "";
    return dDisplay + hDisplay + mDisplay + sDisplay;
  },
  'datetime' : (str, format) => {
    const f = format || 'YYYY-MM-DD HH:mm:ss';
    return dayjs(str).format(f);
  }
}